import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';

import workingHoursTypes from 'utils/WorkingHoursTypes';

import WorkingHours from '../WorkingHours';
import Mileage from '../Mileage';

const MileageOrSpecialMachineryBlock = observer(() => {
  const {
    findTrucksStore: {
      fields: { ordering, advert_item_type },
      resetSearchParameter,
    },
  } = useStores();

  const specialMachineryTypes = new Set(
    workingHoursTypes.map((el) => {
      return el.value;
    }),
  );

  const params = new URLSearchParams(window.location.search);
  const QSFound = [...params.values()].some((item) => specialMachineryTypes.has(item));
  const typeFound = specialMachineryTypes.has(advert_item_type);

  const isSelectWorkingHours = ordering?.includes('working_hours');
  const isQSWorkingHours = [...params.values()].includes('working_hours');

  if (QSFound || typeFound || isQSWorkingHours || isSelectWorkingHours) {
    resetSearchParameter('mileage');
    return <WorkingHours />;
  }

  resetSearchParameter('working_hours');
  return <Mileage />;
});

export default MileageOrSpecialMachineryBlock;
